import Fetch from 'jsx/common/util/_fetch';

export const remove = async (id: string) => {
  return Fetch.delete(`/api/user/${id}/`);
};
